<template>
  <v-col cols="12" sm="12" md="4">
    <v-card>
      <v-card-title class="text-h5"> Most Active Funds </v-card-title>

      <v-card-text>
        <v-table>
          <template #default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Active Shorts</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in results" :key="item.name">
                <td>
                  <router-link :to="'/short/short_position_holder/' + item.permalink">
                    {{ item.name }}
                  </router-link>
                </td>
                <td>{{ item.active_shorts }}</td>
              </tr>
            </tbody>
          </template>
        </v-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { apiRoot } from '@/store/api'
import debounce from 'lodash/debounce'

// Mixins
import FormattersMixin from '@/mixins/formatters'

export default {
  components: {},
  mixins: [FormattersMixin],

  data() {
    return {
      loading: false,
      results: [],
      criteria: {}
    }
  },

  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler() {
        this.updateData()
      }
    }
  },

  methods: {
    updateData: debounce(function () {
      this.loading = true

      apiRoot
        .post('/short_position/most_active', this.criteria)
        .then(response => {
          this.results = response.data
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    }, 750)
  }
}
</script>
